import { useEffect, useMemo } from 'react';
import { Divider, Button, Grid, CircularProgress, Typography } from '@mui/material';
import { AccountInformation } from './components/AccountInformation';
import { CheqInformation } from './components/CheqInformation';
import { Block } from './components/Block';
import { AccountFormProps } from './types';
import { FORM_STATE_OPTIONS, MAIN_COLOR } from './constant';
import { useGetCurrentAccount } from './hooks/useGetCurrentAccount';
import { useAccountForm, useAccountOperations } from './hooks';
import { useDispatch } from 'react-redux';
import { getAssociatedNetworks } from 'redux/slicers/accounts';
export const AccountFormScreen = ({ action }: AccountFormProps) => {
    const dispatch = useDispatch();
    const currentAccount = useGetCurrentAccount();

    const { formData, selectOptions, handleFormChange, createNewAccount } = useAccountForm({
        currentAccount: currentAccount || null,
        action,
    });

    const isServeDomainTainted = useMemo(
        () => Boolean(action === FORM_STATE_OPTIONS.edit && currentAccount?.networks?.some((network) => network.whiteLabelDomain?.tainted === 1)),
        [action, currentAccount?.networks]
    );

    const { handleSubmit, handleChangeServingDomain, isSubmitting } = useAccountOperations({
        currentAccount: currentAccount || null,
        createNewAccount,
        isServeDomainTainted,
    });

    // Fetch account licenses
    useEffect(() => {
        if (action === FORM_STATE_OPTIONS.edit && currentAccount?.id) {
            dispatch(getAssociatedNetworks({ accountId: currentAccount.id }));
        }
    }, [action, currentAccount?.id]);

    const onSubmit = () => handleSubmit(formData);

    return (
        <>
            <Typography
                variant="h4"
                component="h1"
                sx={{
                    textAlign: 'center',
                    marginTop: 3,
                }}
            >
                {action === FORM_STATE_OPTIONS.create ? 'Create New Account' : 'Edit Account'}
            </Typography>

            <AccountInformation value={formData} onChange={handleFormChange} selectOptions={selectOptions} isNewAccount={createNewAccount} />

            <Block content={<Divider sx={{ borderColor: MAIN_COLOR, width: '100%', margin: '32px auto 16px' }} />} />

            <CheqInformation
                value={formData}
                onChange={handleFormChange}
                selectOptions={selectOptions}
                isNewAccount={createNewAccount}
                isServeDomainTainted={isServeDomainTainted}
                onChangeServingDomain={handleChangeServingDomain}
            />

            <Block
                content={
                    <Grid item xs={12} justifyContent="center" display="flex" marginBottom={4}>
                        <Button
                            variant="contained"
                            onClick={onSubmit}
                            color="error"
                            sx={{ backgroundColor: MAIN_COLOR }}
                            disabled={isSubmitting}
                            startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
                        >
                            {isSubmitting ? 'Processing...' : createNewAccount ? 'CREATE' : 'SAVE'}
                        </Button>
                    </Grid>
                }
            />
        </>
    );
};
